export default "__VITE_ASSET__BypaKJP2__"